export const txExplorersPrefixes = {
    polygon: 'https://polygonscan.com/tx',
    base: 'https://basescan.org/tx'
}